import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";

export const LocationSelectorClient_Localization_Fragment =
  graphqlShopifyStorefront(`
  fragment LocationSelectorClient_Localization on Localization {
    availableCountries {
      availableLanguages {
        endonymName
        isoCode
        name
      }
      isoCode
      name
    }
    country {
      isoCode
      name
    }
    language {
      isoCode
      name
    }
  }
`);
